import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';

import { AppContext } from '../../../contexts/AppContext';
import useNavigationPage from '../../../hooks/useNavigationPage';
import { MonthlyClosureDetailDataForm, MonthlyClosureDetailFilters, MonthlyClosureDetailWorkerDataForm } from '../../../app/models/MonthlyClosureDetail';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import MonthlyClosureDetailWorkerDataTable from './tables/MonthlyClosureDetailWorkerDataTable';
import useMonthlyClosureDetailWorkerService from '../../../app/services/hooks/useMonthlyClosureDetailWorkerService';


interface Props {
    monthlyClosureDetailId: number;
    isShow?: boolean;
}

const MonthlyClosureDetailWorkerContainer = ({ monthlyClosureDetailId, isShow = false }: Props) => {
    
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const { 
        getMonthlyClosureDetailWorkersByClosureDetail,
        fetchingGetMonthlyClosureDetailWorkersByClosureDetail
    } = useMonthlyClosureDetailWorkerService();
    

    const [monthlyClosureDetailWorkers, setMonthlyClosureDetailWorkers] = useState<MonthlyClosureDetailWorkerDataForm[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [statuses, setStatuses] = useState<any[]>([]);


    const [monthlyClosureDetailFilter, setMonthlyClosureDetailFilter] = useState<MonthlyClosureDetailFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    useEffect(() => {
        reloadTable();
    }, [
        monthlyClosureDetailFilter.page, 
        monthlyClosureDetailFilter.per_page, 
        monthlyClosureDetailFilter.sort, 
        monthlyClosureDetailFilter.order
    ]);


    const getAllmonthlyClosureDetails = () => {
        getMonthlyClosureDetailWorkersByClosureDetail(monthlyClosureDetailId, monthlyClosureDetailFilter, {
            onSuccess: (response: ServiceResponse) => {
                setMonthlyClosureDetailWorkers(response.data.monthly_closure_detail_workers);
                setTotalRows(response.data.total_rows);
                setStatuses(response.data.statuses);
            },
            onError: (response: ServiceResponse) => {
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
                toast.error(response.message, {
                    autoClose: 2000
                });
            }
        });
    };

    const reloadTable = () => {
        getAllmonthlyClosureDetails();
    };

    

    return (
        <>
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        {isShow ? (
                            <MonthlyClosureDetailWorkerDataTable
                                monthlyClosureDetailWorkers={monthlyClosureDetailWorkers} 
                                totalRows={totalRows} 
                                loading={fetchingGetMonthlyClosureDetailWorkersByClosureDetail}
                                filter={monthlyClosureDetailFilter} 
                                setFilter={setMonthlyClosureDetailFilter} 
                                onSearch={reloadTable}
                                statuses={statuses}
                                // showHistory={showGetHistories}
                                callbackSuccess={reloadTable}
                                // isShow={isShow}
                            />
                        ) : (
                            <MonthlyClosureDetailWorkerDataTable
                                monthlyClosureDetailWorkers={monthlyClosureDetailWorkers} 
                                totalRows={totalRows} 
                                loading={fetchingGetMonthlyClosureDetailWorkersByClosureDetail}
                                filter={monthlyClosureDetailFilter} 
                                setFilter={setMonthlyClosureDetailFilter} 
                                onSearch={reloadTable}
                                statuses={statuses}
                                // showHistory={showGetHistories}
                                callbackSuccess={reloadTable}
                            />
                        )}
                    </div>
                </div>
            </DefaultCard>


        </>
    );
};

export default MonthlyClosureDetailWorkerContainer;